/**
 * Copyright ToolBelt Data Inc., 2021 All Rights Reserved
 */

import React from "react";
import CheckBox from "../../../../../common/components/CheckBox";
import InsightBox from "../InsightBox";

const FilterCheckbox = (props) => {
    const {
        ftOption,
        stateObj,
        handleSubmitFilter,
        handleRemoveFilter
    } = props;

    if (!ftOption) return null;

    const { id, label, operand, insight, isLocked, preview, infoText } = ftOption;

    const isChecked = stateObj?.[id] ?? false;

    const handleChange = (newValue) => {
        if (newValue) {
            handleSubmitFilter({
                ...ftOption,
                value: operand || newValue
            });
        } else {
            handleRemoveFilter({ id });
        }
    };

    return (
        <div>
            <CheckBox
                id={`${id}-check-box`}
                label={label}
                checked={isChecked}
                onChange={handleChange}
                disabled={isLocked}
                lockIcon={isLocked}
                isPreview={preview}
                infoText={infoText}
            />

            {insight && (
                <div style={{ marginTop: '8px' }}>
                    <InsightBox
                        text={insight.text}
                        title={insight.title}
                    />
                </div>
            )}
        </div>
    );
}

export default FilterCheckbox;